/* qm-header.js — Quirky Moose header (sections/qm-header.liquid), 28/9-2026.
   Menus (hover with a short delay, chevron button, first tap on touch), search panel, mobile menu, compact state.
   No dependencies. Dawn's own scripts handle the predictive search (predictive-search.js) and the cart drawer
   (cart-drawer.js opens from #cart-icon-bubble). */
(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 1024px)');
  var OPEN_DELAY = 70;
  var CLOSE_DELAY = 160;

  function init(root) {
    if (!root || root.hasAttribute('data-qm-ready')) return;
    root.setAttribute('data-qm-ready', '');

    var section = root.parentElement;
    var bar = root.querySelector('.qm-hdr__bar');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-qm-hdr-item]'));
    var search = root.querySelector('[data-qm-hdr-search]');
    var searchOpeners = root.querySelectorAll('[data-qm-hdr-search-open]');
    var drawer = root.querySelector('[data-qm-hdr-drawer]');
    var burger = root.querySelector('[data-qm-hdr-burger]');
    var scrim = root.querySelector('[data-qm-hdr-scrim]');
    var sticky = root.getAttribute('data-sticky') !== 'false';
    var html = document.documentElement;
    var lastPointer = 'mouse';
    var openTimer = null;
    var closeTimer = null;
    var lastFocus = null;

    /* Where the bar ends on screen right now — panels and the mobile menu size themselves from it. */
    function measure() {
      var b = bar.getBoundingClientRect().bottom;
      root.style.setProperty('--qh-bottom', Math.max(0, Math.round(b)) + 'px');
    }

    /* ---- Compact ------------------------------------------------------------------------------------------------ */
    var ticking = false;
    function compact() {
      ticking = false;
      if (!sticky || !desktop.matches) { root.classList.remove('is-compact'); return; }
      /* stuck = the section has reached its sticky offset (-40px) */
      var top = section.getBoundingClientRect().top;
      root.classList.toggle('is-compact', top <= -39.5);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(compact); }
    }, { passive: true });
    compact();

    /* ---- Desktop menus ------------------------------------------------------------------------------------------ */
    function isMega(item) { return item.classList.contains('qm-hdr__item--mega'); }

    function setOpen(item, open) {
      var caret = item.querySelector('[data-qm-hdr-caret]');
      item.classList.toggle('is-open', open);
      if (caret) caret.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeMenus(except) {
      items.forEach(function (it) { if (it !== except) setOpen(it, false); });
      var megaOpen = items.some(function (it) { return it.classList.contains('is-open') && isMega(it); });
      root.classList.toggle('has-mega', megaOpen);
    }

    function openMenu(item) {
      if (root.classList.contains('has-search')) closeSearch(false);
      measure();
      closeMenus(item);
      setOpen(item, true);
      root.classList.toggle('has-mega', isMega(item));
    }

    function closeAll() {
      clearTimeout(openTimer); clearTimeout(closeTimer);
      closeMenus(null);
    }

    document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);

    items.forEach(function (item) {
      var top = item.querySelector('.qm-hdr__top');
      var caret = item.querySelector('[data-qm-hdr-caret]');

      /* pointerenter/-leave with pointerType: a tap on a touch screen also fires them, and must not count as hover */
      item.addEventListener('pointerenter', function (e) {
        if (!desktop.matches || e.pointerType !== 'mouse') return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        /* moving from one open item to the next: switch at once */
        var anyOpen = items.some(function (it) { return it.classList.contains('is-open'); });
        openTimer = setTimeout(function () { openMenu(item); }, anyOpen ? 0 : OPEN_DELAY);
      });
      item.addEventListener('pointerleave', function (e) {
        if (!desktop.matches || e.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { setOpen(item, false); closeMenus(null); }, CLOSE_DELAY);
      });

      /* touch: the first tap on «Shop» opens the menu, the second follows the link */
      if (top) {
        top.addEventListener('click', function (e) {
          if (!desktop.matches) return;
          if (lastPointer !== 'mouse' && lastPointer !== 'pen' && !item.classList.contains('is-open')) {
            e.preventDefault();
            openMenu(item);
          }
        });
      }

      if (caret) {
        caret.addEventListener('click', function (e) {
          e.preventDefault();
          if (item.classList.contains('is-open')) { setOpen(item, false); closeMenus(null); }
          else openMenu(item);
        });
      }

      item.addEventListener('focusout', function (e) {
        if (!desktop.matches) return;
        if (e.relatedTarget && item.contains(e.relatedTarget)) return;
        if (e.relatedTarget) { setOpen(item, false); closeMenus(null); }
      });

    });

    /* a tap or click outside closes an open menu */
    document.addEventListener('click', function (e) {
      if (!items.length) return;
      var inside = items.some(function (it) { return it.contains(e.target); });
      if (!inside) closeAll();
    });

    /* ---- Search ------------------------------------------------------------------------------------------------- */
    function openSearch(opener) {
      if (!search) return;
      closeAll();
      if (root.classList.contains('has-drawer')) closeDrawer(false);
      measure();
      lastFocus = opener || document.activeElement;
      root.classList.add('has-search');
      searchOpeners.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var q = search.querySelector('input[type="search"]');
      if (q) {
        q.focus({ preventScroll: true }); /* without it Chrome scrolls the page to the top */
        var v = q.value; q.value = ''; q.value = v; /* caret at the end */
      }
    }
    function closeSearch(restoreFocus) {
      if (!search) return;
      root.classList.remove('has-search');
      searchOpeners.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var ps = search.querySelector('predictive-search');
      if (ps && typeof ps.close === 'function') { try { ps.close(true); } catch (err) {} }
      if (restoreFocus !== false && lastFocus && lastFocus.focus) lastFocus.focus();
    }
    searchOpeners.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (root.classList.contains('has-search')) closeSearch(); else openSearch(b);
      });
    });
    root.querySelectorAll('[data-qm-hdr-search-close]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); closeSearch(); });
    });

    if (scrim) {
      scrim.addEventListener('click', function () {
        if (root.classList.contains('has-search')) closeSearch();
        closeAll();
      });
    }

    /* ---- Mobile menu -------------------------------------------------------------------------------------------- */
    function focusables(el) {
      return Array.prototype.filter.call(
        el.querySelectorAll('a[href], button:not([disabled]), summary, input, [tabindex]:not([tabindex="-1"])'),
        function (n) { return n.offsetParent !== null || n === document.activeElement; }
      );
    }
    function openDrawer() {
      if (!drawer) return;
      if (root.classList.contains('has-search')) closeSearch(false);
      measure();
      root.classList.add('has-drawer');
      html.classList.add('qm-hdr-lock');
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', burger.getAttribute('data-label-close') || '');
      var first = drawer.querySelector('summary, a[href]');
      if (first) first.focus({ preventScroll: true });
    }
    function closeDrawer(restoreFocus) {
      if (!drawer) return;
      root.classList.remove('has-drawer');
      html.classList.remove('qm-hdr-lock');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', burger.getAttribute('data-label-open') || '');
      if (restoreFocus !== false) burger.focus({ preventScroll: true });
    }
    if (burger) {
      burger.addEventListener('click', function () {
        if (root.classList.contains('has-drawer')) closeDrawer(); else openDrawer();
      });
    }
    /* keep Tab inside the open menu and the bar (burger, logo, search, cart) */
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !root.classList.contains('has-drawer')) return;
      var list = focusables(bar).concat(focusables(drawer));
      if (!list.length) return;
      var i = list.indexOf(document.activeElement);
      if (e.shiftKey && (i <= 0)) { e.preventDefault(); list[list.length - 1].focus(); }
      else if (!e.shiftKey && i === list.length - 1) { e.preventDefault(); list[0].focus(); }
    });

    /* the country panel opens over the mobile menu; nothing to do here, but its button must not close the menu */

    /* ---- Global keys and resize --------------------------------------------------------------------------------- */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (document.documentElement.classList.contains('qm-loc-open')) return; /* the country panel closes first */
      if (root.classList.contains('has-search')) { closeSearch(); return; }
      if (root.classList.contains('has-drawer')) { closeDrawer(); return; }
      var openItem = items.filter(function (it) { return it.classList.contains('is-open'); })[0];
      if (openItem) {
        /* focus inside the menu goes back to its chevron, or it would be lost when the panel hides */
        var hadFocus = openItem.contains(document.activeElement);
        closeAll();
        var c = openItem.querySelector('[data-qm-hdr-caret]');
        if (hadFocus && c) c.focus();
      }
    }, true);

    var onChange = function () {
      closeAll();
      if (desktop.matches && root.classList.contains('has-drawer')) closeDrawer(false);
      compact();
    };
    if (desktop.addEventListener) desktop.addEventListener('change', onChange);
    else if (desktop.addListener) desktop.addListener(onChange);

    /* Dawn's cart drawer opens from #cart-icon-bubble; close our own panels first */
    var cartLink = root.querySelector('#cart-icon-bubble');
    if (cartLink) {
      cartLink.addEventListener('click', function () {
        closeAll();
        if (root.classList.contains('has-search')) closeSearch(false);
        if (root.classList.contains('has-drawer')) closeDrawer(false);
      });
    }
  }

  function boot() { document.querySelectorAll('[data-qm-hdr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
